module.exports = __webpack_public_path__ + "static/media/brandmark-designcoor.11ef8780.png";